export interface ILogo {
    data: string;
    name: string;
}
